export default "__VITE_ASSET__BnaK5JC4__"